import * as yup from 'yup';

export const createParameterSchema = yup.object({
  name: yup.string().required('Name is required'),
  code: yup.string().nullable(),
  description: yup.string().nullable(),
  unitId: yup.number().required('Unit is required'),
  // defaultValue: yup
  //   .string()
  //   .required('Default value is required')
  //   .matches(/^[-+]?\d*\.?\d+$/, 'Vui lòng nhập số thập phân hợp lệ'),
  // isActive: yup.boolean().required('Is active is required'),
});

export const updateParameterSchema = yup.object({
  id: yup.number().required('ID is required'),
  name: yup.string().required('Name is required'),
  code: yup.string().nullable(),
  description: yup.string().nullable(),
  unitId: yup.number().required('Unit is required'),
  // defaultValue: yup
  //   .string()
  //   .required('Default value is required')
  //   .matches(/^[-+]?\d*\.?\d+$/, 'Vui lòng nhập số thập phân hợp lệ'),
  // isActive: yup.boolean().required('Is active is required'),
});
